import { StoresRepository } from '@lib/api/repository/stores/stores.repository';
import { AdminStoresFilters, StoreInput, StoreMediaKind } from '@lib/types';

export default class StoresService {
  uploadMedia(kind: StoreMediaKind, file: File) {
    return this.repository.uploadMedia(kind, file);
  }

  setRetailer(id: string, enabled: boolean) {
    return this.repository.setRetailer(id, enabled);
  }

  checkSlug(slug: string, signal?: AbortSignal) {
    return this.repository.checkSlug(slug, signal);
  }

  constructor(private repository: StoresRepository) {}
  list(signal?: AbortSignal) {
    return this.repository.list(signal);
  }

  find(slug: string, signal?: AbortSignal) {
    return this.repository.find(slug, signal);
  }

  findMine(signal?: AbortSignal) {
    return this.repository.findMine(signal);
  }

  save(input: StoreInput) {
    return this.repository.save(input);
  }

  listAdmin(filters: AdminStoresFilters, signal?: AbortSignal) {
    return this.repository.listAdmin(filters, signal);
  }

  setActive(id: string, active: boolean) {
    return this.repository.setActive(id, active);
  }

  setMineActive(active: boolean) {
    return this.repository.setMineActive(active);
  }

  listReviews(slug: string, signal?: AbortSignal) {
    return this.repository.listReviews(slug, signal);
  }

  findProgress(slug: string, signal?: AbortSignal) {
    return this.repository.findProgress(slug, signal);
  }

  acknowledgePromotion() {
    return this.repository.acknowledgePromotion();
  }
}
